/**
 * DevExtreme (esm/__internal/ui/number_box/m_number_box.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../../core/component_registrator";
import NumberBoxMask from "./m_number_box.mask";
registerComponent("dxNumberBox", NumberBoxMask);
export default NumberBoxMask;
